import { useEditor, useNode } from "@craftjs/core";
import { Col, Switch } from "antd";
import { Form, Input } from "components/Form";
import React, { useEffect, useState } from "react";
import { ImQuill } from "react-icons/im";
import IntlMessages from "util/IntlMessages";
import { MyQuillEditor } from "@/routes/system/FormSetup/components/SfQuillEditor";
import { deleteButton, EditorCollector, getId, NodeCollector, registerComponent, SpLayoutSetting, SpStyleSetting, syncPageState, updatePageState } from "@/routes/system/PageSetup/components/common";

const SpQuillEditorSetting = () => {
  return (
    <>
      <Form.Item name="title" label="title">
        <Input className="item-property" />
      </Form.Item>
      <Form.Item name="staticContent" label="content">
        <Input.TextArea className="item-property" />
      </Form.Item>
      <Form.Item name="readOnly" label="read-only" valuePropName="checked">
        <Switch className="item-property"/>
      </Form.Item>
      <Form.Item name="disabled" label="disabled" valuePropName="checked">
        <Switch className="item-property" />
      </Form.Item>
      <Form.Item name="advanced" label="advanced" valuePropName="checked">
        <Switch className="item-property" />
      </Form.Item>
      <Form.Item name="imageBase64" label="image" valuePropName="checked">
        <Switch className="item-property" />
      </Form.Item>
      <Form.Item name="highlight" label="highlight" valuePropName="checked">
        <Switch className="item-property" />
      </Form.Item>
      <Form.Item name="fontstyle" label="font style" valuePropName="checked">
        <Switch className="item-property" />
      </Form.Item>
      <SpStyleSetting />
      <SpLayoutSetting />
    </>
  )
}

export const SpQuillEditor = ({ ...props }) => {
  const { actions: {setProp}, connectors: { connect, drag }, selected, style } = useNode(NodeCollector);
  const { actions, selectedNode } = useEditor(EditorCollector);
  const dbtn = deleteButton(selected, selectedNode, actions)
  const onChange = (value) => {
    setProp(props => {
      props.staticContent = value;
    });
  }
  return (
    <SppQuillEditor doRef={ref => connect(drag(ref))} onChange={onChange} dbtn={dbtn} {...props} selectedStyle={style} />
  )
}

export const SppQuillEditor = ({
  doRef, pageKey, selectedStyle, dbtn, value, onChange, staticContent, readOnly,
  itemKey, pageState, setPageState, ...otherProps }) => {
  let style = otherProps.style || {};
  style = { ...style, ...selectedStyle };
  const props = { ...otherProps, style }
  const [myValue, setMyValue] = useState(staticContent)

  useEffect(() => {
    syncPageState({itemKey, myValue, setMyValue, pageState, setPageState})
  },[itemKey, myValue, pageState, setPageState])

  const onMyChange = (myValue) => {
    updatePageState({itemKey, myValue, setMyValue, pageState, setPageState})
  }

  return (
    <Col ref={doRef}  {...props}>
      <MyQuillEditor readOnly={readOnly} value={myValue} onChange={onMyChange} designer={!!doRef} {...otherProps}/>
      {dbtn}
    </Col>
  );
}
SppQuillEditor.enablePageState = true;

SpQuillEditor.craft = {
  displayName: "Quill Editor",
  related: {
    settings: SpQuillEditorSetting
  }
}

registerComponent({
  key: "SpQuillEditor",
  component: SpQuillEditor,
  runtimeComponent: SppQuillEditor,
  template: <SpQuillEditor itemKey={getId('quilleditor')} className="sp-quilleditor"
    title={"Quill Editor"} span={24} />,
  title: <IntlMessages id="system.form.library.quilleditor" text="Quill Editor" />,
  icon: <ImQuill  className="react-icons icon-bs"/>,
  type: "Component",
  subtype: "input",
  sequence: 13,
});

export default SpQuillEditor;